import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { SpinnerIcon } from '@stpkg/stand-react';

import styles from './index.module.css';

export interface RSLoadingOverlayProps {
  isLoading: boolean;
}

export const RSLoadingOverlay: React.FC<RSLoadingOverlayProps> = ({
  isLoading,
}) => {
  const [isDisappeared, setIsDisappeared] = useState(true);

  useEffect(() => {
    if (isLoading) {
      setIsDisappeared(false);
    } else {
      // transition-durationの分だけ遅延させる
      setTimeout(() => {
        setIsDisappeared(true);
      }, 200);
    }
  }, [isLoading]);

  return (
    <div
      className={classnames(
        'z-9',
        // 不可視の状態で常に画面を占有することのないように通常時は w-0 h-0 にしておく
        // isLoadingを用いると直ちに変更が行われるためtransition-durationを考慮したisDisappearedを用いる
        !isDisappeared ? 'w-screen' : 'w-0',
        !isDisappeared ? 'h-screen' : 'h-0',
        'fixed',
        'bottom-0',
        'left-0',
        'z-9',
        'flex',
        'justify-center',
        'items-center',
        'transition',
        isLoading ? 'bg-[#fffffff5]' : 'bg-[#ffffff00]',
        isLoading ? 'backdrop-blur-[10px]' : 'backdrop-blur-none',
        'overflow-hidden',
        'pointer-events-none',
      )}
    >
      <div className={styles['icon-wrapper']}>
        <SpinnerIcon
          width="56"
          height="56"
          viewBox="0 0 48 48"
          className={classnames(
            'fill-gray-50',
            'transition',
            isLoading ? 'opacity-100' : 'opacity-0',
          )}
        />
      </div>
    </div>
  );
};
